export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8205.0df3f654.jpg";